export default __webpack_public_path__ + "static/section_9_item_1-c544decc4a5af1c99ad395b2fecc19c8.png";